import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Applies the MarTech-inspired dark neon branding to public marketing pages only.
 * Admin, coach portals, blog/toolkit content and coach sites keep the default theme.
 */
const MARKETING_ROUTES = new Set([
  "/",
  "/about",
  "/contact",
  "/press",
  "/pricing",
  "/success-stories",
  "/coaches",
  "/partners",
  "/institute-partners",
  "/connect",
]);

const MarketingTheme = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = pathname !== "/" && pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
    const isMarketing = MARKETING_ROUTES.has(path) || path.startsWith("/press/");
    const root = document.documentElement;
    root.classList.toggle("theme-martech", isMarketing);
    return () => root.classList.remove("theme-martech");
  }, [pathname]);

  return null;
};

export default MarketingTheme;
